import React, { useState } from 'react'
import { GatsbyImage } from "gatsby-plugin-image";
import HTMLContent from './Content'
import TextAvatar from './TextAvatar'
import './testimonial.sass'

function Testimonial({ node, image, card }) {
  const [isreadmore, setisreadmore] = useState(false)
  const contentlength = node.content.length
  const content = node.content.slice(4, contentlength - 5)
  const openTag = node.content.slice(0, 4)
  const closetag = node.content.slice(contentlength - 5, contentlength)
  const shortContent = `${openTag + content.slice(0, 190)}....${closetag}`
  return (
    <div className={`testimonial ${card ? 'testimonial-card' : ''}`}>
      <div className="media">
        <figure className="media-left">
          {image && <GatsbyImage alt="" image={image} height="96px" width="96px" />}
          {!image && <TextAvatar name={node.userDetails.userName} />}
        </figure>

        <div className="media-content">
          <p className="title is-4">{node.userDetails.userName}</p>
          <p className="subtitle is-6">{node.userDetails.details}</p>
        </div>
      </div>
      <HTMLContent
        content={
          contentlength > 190 && !isreadmore ? shortContent : node.content
        }
        className="testimonial-content"
      />
      {contentlength > 190 && !isreadmore && (
        <span
          className="testimonial-read-more"
          onClick={() => setisreadmore(true)}
        >
          Read More
        </span>
      )}
      {isreadmore && (
        <span
          className="testimonial-read-more"
          onClick={() => setisreadmore(false)}
        >
          Read Less
        </span>
      )}
    </div>
  );
}

export default Testimonial
